import React, { useMemo } from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { Box, xcss } from '@atlaskit/primitives';
import HelpPanelLink from '@atlassian/jira-help-panel-button/src/index.tsx';
import LoadingFileError from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/loading-file-error/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import messages from './messages.tsx';
import { SizeLimitErrorWithNoCTA } from './size-limit-error-no-cta/index.tsx';
import { getIssueLimitMessages } from './utils.tsx';

const issueLimitsIPHArticleId = '1KMwTxMBNiDPhaHMDlfT4u';

/**
 * TODO: update primaryAction to redirect to board filter via savedFilterId
 * TODO: accommodate TMP empty states by copying existing version
 */
const SizeLimitError = () => {
	const { formatMessage } = useIntl();
	const { name } = useCurrentRoute();
	const [{ location }] = useRouter();

	const { headerMessage, descriptionMessage } = useMemo(() => getIssueLimitMessages(name), [name]);

	const boardSettingsUrl = `${location.pathname}?config=filter`;

	return (
		<EmptyState
			renderImage={getAkEmptyStateRenderImageFn(LoadingFileError)}
			header={formatMessage(headerMessage)}
			description={formatMessage(descriptionMessage)}
			primaryAction={
				<Button href={boardSettingsUrl} appearance="primary">
					{formatMessage(messages.editFilter)}
				</Button>
			}
			tertiaryAction={
				<HelpPanelLink
					appearance="link"
					articleId={issueLimitsIPHArticleId}
					fallbackComponent={null}
				>
					{formatMessage(
						fg('jira-issue-terminology-update-m4')
							? messages.moreLinkTextIssueTerminologyRefreshM4
							: messages.moreLinkText,
					)}
				</HelpPanelLink>
			}
		/>
	);
};

const SizeLimitErrorEmptyState = () => {
	const { name } = useCurrentRoute();

	const showErrorWithNoCTA = name === 'servicedesk-boards';

	return (
		<Box xcss={containerStyles}>
			{showErrorWithNoCTA ? <SizeLimitErrorWithNoCTA /> : <SizeLimitError />}
		</Box>
	);
};

const containerStyles = xcss({
	width: '100%',
});

export default SizeLimitErrorEmptyState;
